<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center">
    <button (click)="goBack()" class="btn btn-primary"><fa-icon [icon]="faCircleArrowLeft"></fa-icon></button>
    <h1 class="fs-2 fw-light mb-0">Manage Property</h1>
    <button (click)="goHome()" class="btn btn-info"><fa-icon [icon]="faHomeAlt"></fa-icon></button>
  </div>

  <div class="row g-3 mt-4">
    <div class="col-12 col-md-6">
      <button (click)="manageMaintenance()" class="btn btn-primary btn-lg text-start w-100">
        <fa-icon [icon]="faWrench"></fa-icon> Manage Maintenance
      </button>
    </div>
    <div class="col-12 col-md-6">
      <button (click)="manageRates()" class="btn btn-primary btn-lg text-start w-100">
        <fa-icon [icon]="faPercent"></fa-icon> Manage Rates
      </button>
    </div>
    <div class="col-12 col-md-6">
      <button (click)="manageLicense()" class="btn btn-primary btn-lg text-start w-100">
        <fa-icon [icon]="faFileContract"></fa-icon> Manage License
      </button>
    </div>
  </div>
</div>
